import React from 'react';
import Burger from './burger';
import '../styles/nav.scss';

const Nav = ({ children, background }) => {

    const menuOptions = {
        'case studies': '/case-studies/',
        'blog': '/blog/',
        'careers': '/careers/',
        'contact': '/#contact'
    }

    return (
        <nav className={"nav " + background}>
            <a href="/" className="logo">
                <img src="/images/54-bit-studios-wordmark.svg" alt="54 Bit Studios" width="1593" height="743" />
            </a>
            <div className="link-list">
                {Object.keys(menuOptions).map(option => {
                    return (
                        <a href={menuOptions[option]} className="ff">{option}</a>
                    )
                })}
            </div>
            <Burger menuOptions={menuOptions} />
        </nav>
    )

}

export default Nav